import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import { ArrowUpIcon } from "@chakra-ui/icons";

export default function TotalDepartment() {
  return (
    <ReportCard title="Total Directorates" text={30} icon={<ArrowUpIcon />} />
  );
}
